import { render, staticRenderFns } from "./SocialHappeningGroup.vue?vue&type=template&id=857e4db2&scoped=true&"
import script from "./SocialHappeningGroup.vue?vue&type=script&lang=js&"
export * from "./SocialHappeningGroup.vue?vue&type=script&lang=js&"
import style0 from "./SocialHappeningGroup.vue?vue&type=style&index=0&id=857e4db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857e4db2",
  null
  
)

export default component.exports